
/*
ashraf   10/16/2022  2700708915   added code comments in search, add user management.
Akhlaque 10/26/2022  2700708915   renamed clear button to reset
prakash 26/10/2022 2700708915 added classes for buttons.
ashraf 10/27/2022  2700708915  user management ux changes
Rohini 10/28/2022  2700708915  added classname for the global textfeilds
Lalitha 10/26/2022  2700708915   renamed clear button to reset
Raghu 11/03/2022 2700708915  Responsive Alignment Fixes
Ashraf 12/07/2022  2700708915 fixed user login name field
Lalitha 12/09/2022  2700708915  Added reusable backButtonText
Prakash 12/22/2022 2700708915 Removed Card Component.
suresh peddavoora 02/24/2023 2700708915 New UI changes
suresh peddavoora 03/01/2023 2700708915 New UI changes
suresh peddavoora 03/14/2023 2700708915 Tables and fields alignments
Prakash 12/04/2023 2700708915 change checkbox color and fixed alignments issue in tab view.
Prakash 5/05/2023 2700708915 add theming color class name
*/

import {
  Grid,
  Button,
  TextField,
  FormControl,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import {Form, Formik} from 'formik';
import React, {useState, useContext} from 'react';
import ErrorBoundaryForComponents from '../../../util/ErrorBoundaryForComponents';
import {ThemeContext} from '../../../themes/ThemeProvider';
import UnlockUser from './UnlockUserTable';
import {ArrowBack} from '@material-ui/icons';
import {backButtonText} from '../../../util/Content';

// search form to search users who are locked (2700708915)
const SearchForm = ({setValue, setRecordFormatCode, selected, setSelected, setCompanyCode}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  // search user form initial values (2700708915)
  const initialValues = {
    userName: '',
    emailId: '',
    isActive: true,
    companyCode: [],
    roles: '',
    location: '',
    departmentDivision: '',
  };
  const [submit, setSubmit] = useState(false);
  const [searchData, setSearchData] = useState(false);

  // search details submit, locked users details table render (2700708915)
  const handleSubmit = (data) => {
    setSubmit(true);
    setSearchData(data);
  };

  return (
    <div>
      <div className="button-table-spacing-mb justify-content-start new-standard-textfields">
        <Button
          variant="outlined"
          type="button"
          className={`search-btn mx-1`}
          onClick={() => {
            setValue(0);
          }}
        >
          <ArrowBack className="mr-2" />
          {backButtonText}
        </Button>
      </div>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        enableReinitialize
      >
        {(props) => {
          const {values, handleChange, handleReset, handleBlur} = props;
          return (
            <div>
              <Form autoComplete="off">
                <div>
                  <ErrorBoundaryForComponents>
                    <Grid container className="global-field-textfields new-standard-textfields"spacing={2}>
                      <>
                        <Grid item xs={6} sm={6} md={4} lg={3} className="form-group">
                          <TextField
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter Email-Id`}
                            label="Email Id"
                            className={` ${classes.labelName}`}
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            name="emailId"
                            value={values.emailId}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} md={3} lg={3} className="form-group">
                          <TextField
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter User Login Name`}
                            label="User Login Name"
                            className={` ${classes.labelName}`}
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            name="userName"
                            value={values.userName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} md={3} lg={3} className="form-group">
                          <TextField
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter Location`}
                            label="Location"
                            className={` ${classes.labelName}`}
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            name="location"
                            value={values.location}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={6} md={2} lg={3} className="admin-checkbox">
                          <FormControl margin="dense">
                            <FormControlLabel
                              className={`check-block`}
                              control={
                                <Checkbox
                                  onChange={handleChange} // for future use
                                  name="isActive"
                                  checked={values.isActive}
                                />
                              }
                              label="Is Active"
                              labelPlacement="end"
                            />
                          </FormControl>
                        </Grid>
                      </>
                    </Grid>
                  </ErrorBoundaryForComponents>
                  <div className="button-table-spacing-mb new-standard-textfields">
                    <Button
                      variant="outlined"
                      className={`mr-1 reset-btn ${classes.buttonRoot}`}
                      onClick={() => {
                        handleReset();
                        setSearchData(initialValues);
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      type="submit"
                      variant="outlined"
                      className={`ml-1 search-btn ${classes.buttonRoot}`}
                    >
                      Search
                    </Button>
                  </div>
                </div>
              </Form>
              {/* {isLoading && <PageLoader />} */}
            </div>
          );
        }}
      </Formik>
      <Grid>
        <UnlockUser submit={submit} searchData={searchData} />
      </Grid>
    </div>
  );
};

export default SearchForm;
